/**
 * PickerColumn 组件的 emit 事件声明
 * 基于方案设计文档生成
 */
export const emits = [
  /** 选中项改变时触发 */
  'change',
  /** 点击选项时触发 */
  'click-option',
];
